/**
 * Peer — unified contact model normalizing LLM bots and worker roles
 * into a single shape: { roleId, type, displayName, description, roleType, online, ... }
 */

export function createPeerFromBot(bot) {
  return {
    roleId: bot.botId,
    type: 'llm-bot',
    displayName: bot.displayName,
    description: bot.description,
    roleType: 'chat',
    online: true,
    botConfig: bot,
  }
}

export function createPeerFromWorker(role) {
  return {
    roleId: role.roleId,
    type: 'worker',
    displayName: role.displayName,
    description: role.description,
    roleType: role.roleType,
    typeName: role.typeName,
    online: role.online ?? false,
    workerPublicKey: role.roleId,
  }
}

/**
 * Merge LLM bots and worker roles into a single Peer list.
 * @param {Array} llmBots - Bot configs
 * @param {Array} workerRoles - Worker role objects
 * @param {string[]} [excludeIds] - Bot IDs to exclude (e.g. built-in bots handled separately)
 */
export function mergePeers(llmBots, workerRoles, excludeIds) {
  const exclude = excludeIds ? new Set(excludeIds) : null
  const botPeers = (llmBots || [])
    .filter(b => !exclude || !exclude.has(b.botId))
    .map(createPeerFromBot)
  const workerPeers = (workerRoles || []).map(createPeerFromWorker)
  return [...botPeers, ...workerPeers]
}
